import React, { useState, useEffect } from "react";
import { object, string, array } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import CardImage from "../../atoms/CardImage";
import { getSlug, getStoryHeadline, getCollectionName } from "../../utils/utils";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";

import "./fourPhotoStoryCards.m.css";

const FourPhotoStoryCards = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const [isMobile, setIsMobile] = useState(false);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  const storiesToLoad = get(collection, ["associated-metadata", "number_of_stories_to_show"], 4);
  const storyList =
    collection.items.length > 0
      ? collection.items.filter((item) => item.type === "story" && item.story).slice(0, storiesToLoad)
      : null;
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const headlineStyle = publisherAttributes.lang === "en" ? "en-story-headline" : "bn-story-headline";
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  return (
    <div
      styleName={`four-photo-story-4s`}
      className={`four-photo-story-cards ${publisherAttributes.lang}-four-photo-story-4s-base`}
    >
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="story-container" className={`${publisherAttributes.lang}-story-container`}>
        {storyList.map(({ story }, index) => {
          const storyHeadline = getStoryHeadline(story);

          return (
            <div styleName="story-card" key={index}>
              <div styleName="image-wrapper">
                <Link href={story.url}>
                  <CardImage
                    story={story}
                    defaultWidth={300}
                    aspectRatio={global.deviceWidth < 876 ? [3, 2] : [16, 9]}
                    imageType={global.deviceWidth < 876 ? "image3x2" : "image16x9"}
                    widths={global.deviceWidth < 876 ? [120] : [300]}
                    showAlternateImage={true}
                  />
                </Link>
                <div styleName="top-right-border"></div>
                <div styleName="top-right-bottom-border"></div>
              </div>

              <div styleName="headline-wrapper">
                {story.subheadline && (
                  <Link href={story.url}>
                    <Headline
                      text={story.subheadline}
                      headerLevel={3}
                      className="section-name"
                      styleName={subHeadlineStyle}
                    />
                  </Link>
                )}
                <Link href={story.url}>
                  <Headline
                    text={storyHeadline}
                    headlineType={21}
                    headerLevel={2}
                    className="story-headline"
                    styleName={headlineStyle}
                  />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

FourPhotoStoryCards.propTypes = {
  accentColor: string,
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FourPhotoStoryCards);
